'use strict';

import buildComparisonAlert from '../common/buildComparisonAlert';

export default function objectOptions () {
    let $button = $('.js-object-action'),
        $idHld = $('.js-object-id-hld'),
        objectId = $idHld.attr('data-id');

    if (
        !$button.length ||
        !$idHld.length ||
        typeof objectId === 'undefined'
    ) {
        return;
    }

    let toggleOption = (type, state) => {
        let $currentBtn = $button.filter(`[data-action="${type}"]`);

        $currentBtn.attr('data-state', state);

        if (state) {
            $currentBtn.addClass('active');
        } else {
            $currentBtn.removeClass('active');
        }
    };

    $button.on('click', function (e) {
        e.preventDefault();

        let $this = $(this),
            action = $this.attr('data-action'),
            wasActive = $this.attr('data-state');

        if (
            typeof action === 'undefined' ||
            typeof wasActive === 'undefined'
        ) {
            return;
        }

        wasActive = wasActive === 'true';

        if (action === 'comparison') {
            $.ajax({
                method: 'POST',
                url: $this.attr('data-href').replace('__state', !wasActive).replace('__dateTimeJs', new Date().getTime()),
            }).done((data) => {
                let $alertHld = $('.js-alerts-hld'),
                    $alert = $('.js-alert[data-type="comparison"]'),
                    response = data ? JSON.parse(data) : null;

                if (!response) {
                    return;
                }

                if ($alert.length) {
                    if (response.count) {
                        $alert.siblings().remove();
                        /* jshint camelcase:false */
                        $alert.find('.js-alert-msg').text(response.count_str);
                        /* jshint camelcase:true */
                    } else {
                        $alert.remove();
                        /* jshint camelcase:false */
                        $alertHld.append($([
                            `<div class="alert alert-error t-a-c" data-type="comparison">`,
                                response.count_str,
                            `</div>`].join('')));
                        /* jshint camelcase:true */
                    }
                } else if (response.count) {
                    /* jshint camelcase:false */
                    $alertHld.append(buildComparisonAlert(response.count_str));
                    /* jshint camelcase:true */
                }
            });
        } else if (action === 'follow') {
            if (!wasActive) {
                $.ajax({
                    method: 'POST',
                    url: $this.attr('data-href-add'),
                });
            } else {
                $.ajax({
                    method: 'POST',
                    url: $this.attr('data-href-remove'),
                });
            }
        }

        toggleOption(action, !wasActive);
    });
}
